
const newModel = () => {
    return {
        thethaoThanhtichCanhanId: null,
        thethaoGiaithidauId: null,
        tenThethaoGiaithidau: null,
        tenThethaoBomon: null,
        thethaoBomonId: null,
        thethaoHangcanId: null,
        tenThethaoHangcan: null,
        tenThethaoThanhtich: null,
        thethaoThanhtichId: null,
        vanDongVienId: null,
        tenVanDongVien: null,
        tenHuanLuyenVien: null,
        huanLuyenVienId: null,
        huanLuyenVien2Id: null,
        tenHuanLuyenVien2: null,
        ghiChu: null,
        stt: null,
        enabled: null,

        dateCreated: null,
        userCreated: null,
        dateModified: null,
        userModified: null,
        isDeleted: null,
        userDeleted: null,
        dateDeleted: null,
        tenUserCreated: null,
        tenUserModified: null,
        tenUserDeleted: null
    }
}

const newFEModel = () => {
    return {
        thethaoThanhtichCanhanId: null,
        thethaoGiaithidauId: null,
        thethaoBomonId: null,
        thethaoHangcanId: null,
        thethaoThanhtichId: null,
        vanDongVienId: null,
        huanLuyenVienId: null,
        huanLuyenVien2Id: null,
        ghiChu: null,
        stt: "0",
        enabled: true,
    }
}

const fromJson = (item) => {
    return {
        thethaoThanhtichCanhanId: item.thethaoThanhtichCanhanId,
        thethaoGiaithidauId: item.thethaoGiaithidauId,
        tenThethaoGiaithidau: item.tenThethaoGiaithidau,
        tenThethaoBomon: item.tenThethaoBomon,
        thethaoBomonId: item.thethaoBomonId,
        thethaoHangcanId: item.thethaoHangcanId,
        tenThethaoHangcan: item.tenThethaoHangcan,
        tenThethaoThanhtich: item.tenThethaoThanhtich,
        thethaoThanhtichId: item.thethaoThanhtichId,
        vanDongVienId: item.vanDongVienId,
        tenVanDongVien: item.tenVanDongVien,
        tenHuanLuyenVien: item.tenHuanLuyenVien,
        huanLuyenVienId: item.huanLuyenVienId,
        huanLuyenVien2Id: item.huanLuyenVien2Id,
        tenHuanLuyenVien2: item.tenHuanLuyenVien2,
        ghiChu: item.ghiChu,
        stt: item.stt,
        iocId: item.iocId,
        iocEnabled: item.iocEnabled,
        iocDateUpdated: item.iocDateUpdated,
        enabled: item.enabled,
        dateCreated: item.dateCreated,
        userCreated: item.userCreated,
        dateModified: item.dateModified,
        userModified: item.userModified,
        isDeleted: item.isDeleted,
        userDeleted: item.userDeleted,
        dateDeleted: item.dateDeleted,
        tenUserCreated: item.tenUserCreated,
        tenUserModified: item.tenUserModified,
        tenUserDeleted: item.tenUserDeleted
    }
}

const parseModeltoFEModel = (item) => {
    return {
        thethaoThanhtichCanhanId: item.thethaoThanhtichCanhanId,
        thethaoGiaithidauId: item.thethaoGiaithidauId,
        thethaoBomonId: item.thethaoBomonId,
        thethaoHangcanId: item.thethaoHangcanId,
        tenThethaoThanhtich: item.tenThethaoThanhtich,
        thethaoThanhtichId: item.thethaoThanhtichId,
        vanDongVienId: item.vanDongVienId,
        huanLuyenVienId: item.huanLuyenVienId,
        huanLuyenVien2Id: item.huanLuyenVien2Id,
        ghiChu: item.ghiChu,
        stt: item.stt,
        enabled: item.enabled,
    }
}

const errors = () => {
    return {
        thethaoThanhtichCanhanId: null,
        thethaoGiaithidauId: null,
        thethaoBomonId: null,
        thethaoHangcanId: null,
        thethaoThanhtichId: null,
        vanDongVienId: null,
        huanLuyenVienId: null,
        huanLuyenVien2Id: null,
        ghiChu: null,
        stt: null,
        enabled: null,
        enabledDisplay: null,
        iocId: null,
        iocEnabled: null,
        iocEnabledDisplay: null,
        iocDateUpdated: null,
    }
}

const newPagingSearchModel = () => {
    return {
        pageNumber: null,
        pageSize: null,
        sort: null,
        thethaoThanhtichCanhanId: null,
        thethaoGiaithidauId: null,
        thethaoBomonId: null,
        thethaoHangcanId: null,
        thethaoThanhtichId: null,
        vanDongVienId: null,
        huanLuyenVienId: null,
        huanLuyenVien2Id: null,
        enabled: null,
    }

}

const newSearchModel = (item) => {
    return {
        thethaoDoiId: item.thethaoDoiId,
        thethaoThanhtichCanhanId: item.thethaoThanhtichCanhanId,
        thethaoGiaithidauId: item.thethaoGiaithidauId,
        thethaoBomonId: item.thethaoBomonId,
        thethaoHangcanId: item.thethaoHangcanId,
        thethaoThanhtichId: item.thethaoThanhtichId,
        vanDongVienId: item.vanDongVienId,
        huanLuyenVienId: item.huanLuyenVienId,
        huanLuyenVien2Id: item.huanLuyenVien2Id,
        enabled: item.enabled,
    }
}

export const thanhTichCaNhanTheThaoVHModel = {
    newModel,
    newFEModel,
    parseModeltoFEModel,
    fromJson,
    newPagingSearchModel,
    newSearchModel,
    errors,
}


